"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contrastRatioHsl = exports.contrastRatioRgb = void 0;
var tslib_1 = require("tslib");
var hsl_to_rgb_1 = require("../basic-conversion/hsl-to-rgb");
var relative_luminance_1 = require("./relative-luminance");
/**
 * @description
 * Contrast ratios can range from 1 to 21.
 * link: https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 */
var contrastRatioRgb = function (rgb1, rgb2) {
    var a = (0, relative_luminance_1.relativeLuminance)(rgb1);
    var b = (0, relative_luminance_1.relativeLuminance)(rgb2);
    var _a = tslib_1.__read(a < b ? [b, a] : [a, b], 2), relativeLuminanceLighter = _a[0], relativeLuminanceDarker = _a[1];
    return (relativeLuminanceLighter + 0.05) / (relativeLuminanceDarker + 0.05);
};
exports.contrastRatioRgb = contrastRatioRgb;
var contrastRatioHsl = function (hsl1, hsl2) {
    return (0, exports.contrastRatioRgb)((0, hsl_to_rgb_1.hslToRgb)(hsl1), (0, hsl_to_rgb_1.hslToRgb)(hsl2));
};
exports.contrastRatioHsl = contrastRatioHsl;
